<template>
    <el-dialog class="dialog" :visible="dialogs.areas" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Добавить область профессиональной деятельности</h3>
            </div>
        </div>

        <div class="dialog__inner">
            <div class="dialog__content">
                <form class="search-form">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input" @keydown.enter.prevent.stop>

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    max-height="300"
                    ref="table"
                    row-key="id"
                    :data="filteredData"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                            width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox @change="handleSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable
                        :min-width="10"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>

                <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                <el-table
                    cell-class-name="table__cell"
                    class="table table_second"
                    header-cell-class-name="table__title"
                    max-height="300"
                    row-key="id"
                    :show-header="false"
                    :data="selection"
                    :default-sort="{ prop: 'code', order: 'ascending' }"
                >
                    <el-table-column
                        width="24"
                    >
                        <template slot-scope="scope">
                            <div class="table_flex">
                                <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Код"
                        prop="code"
                        sortable
                        :min-width="10"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                    <el-table-column
                        label="Название"
                        prop="name"
                        sortable
                        :min-width="90"
                        :sort-orders="['ascending', 'descending']"
                    >
                    </el-table-column>
                </el-table>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные ОПД</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import dialog from '@/mixins/dialog';

export default {
    mixins: [ dialog ],
    methods: {
        ...mapActions('editor', ['LOAD_KINDS_BY_AREAS', 'SAVE_KINDS']),
        ...mapMutations('editor', ['SET_SELECTED_AREAS']),
        closeDialog() {
            this.selection = []
            
            this.elDialogs.areas = false;
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        async submitSelected() {
            const newSelection = [...this.selectedAreas, ...this.selection];
            this.SET_SELECTED_AREAS(newSelection);
            const selectionsIds = this.selection.map((item) => item.id)

            const kindsByAreas = await this.LOAD_KINDS_BY_AREAS(selectionsIds.join(','));
            for (const id of selectionsIds) {
                const params = {
                    area_id: id,
                    kinds: kindsByAreas.filter(el => el.area_id === id).map((el) => el.id) || []
                }
                await this.SAVE_KINDS(params);
            }

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['areas', 'groupItemsBy', 'kinds', 'selectedAreas']),
        filtered() {
            return this.areas.filter((item) => !this.selectedAreas.some((selectedArea) => selectedArea.id === item.id));
        },
        tableData() {
            return !this.searchValue ? this.filtered : this.filtered.filter((item) => String(item.code).toLowerCase().includes(this.searchValue.toLowerCase()) || item.name.toLowerCase().includes(this.searchValue.toLowerCase()));
        },
        filteredData() {
            return this.tableData.filter(el => !this.selection.find(select => select.id === el.id))
        }
    }
}
</script>
